import { pipe } from 'fp-ts/function';
import * as E from 'fp-ts/lib/Either';
import * as TE from 'fp-ts/lib/TaskEither';

import { defaultLanguage } from '../../../../../languages';

import { UserAnalytics } from '@domain/auth';

import Individual from '@domui-utils/workflow/individual';

export const fetchPreferredLangs = (
  profileId: string | null
): UserAnalytics => {
  const wfService = new Individual();

  return pipe(
    TE.tryCatch(async () => {
      if (profileId) {
        const perfLang = await wfService.getPreferredLanguage(
          profileId as string
        );
        return perfLang?.shortCode ?? defaultLanguage;
      }
      return defaultLanguage;
    }, E.toError)
  );
};
